import { gql } from '@apollo/client';

const GET_FOOTER = gql`
  query GetSectionBySlug($slug: String!) {
    sectionsBy(slug: $slug) {
      footer {
        titulo_footer
        text_boton {
          title
          url
        }
      }
    }
  }
`;

export { GET_FOOTER }